module.exports = __webpack_public_path__ + "assets/img/u0.bdda7e1c.png";